module.exports = __webpack_public_path__ + "fonts/Montserrat_Regular_Latin_Ext.97638b9a.woff2";